import React from 'react';
import { connect } from 'react-redux';
import { startLogout } from '../../actions/auth';
import { Link } from 'react-router-dom';

export const Logout = ({ startLogout }) => (
      <div className="logout">
          <button className="button button--link" onClick={startLogout}>Logout</button>
      </div>
);
  
const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout())
});
  
export default connect(undefined, mapDispatchToProps)(Logout);
  


// WEBPACK FOOTER //
// ./src/components/economicModel/Logout.js